// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.c-item[data-v-21334ee4] {
  padding-left: .75rem;
  padding-right: .75rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
}
`, "",{"version":3,"sources":["webpack://./src/vue/components/modal-tree/modal-tree.vue"],"names":[],"mappings":";AAyNA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":["\n.c-item {\n  padding-left: .75rem;\n  padding-right: .75rem;\n  padding-top: .5rem;\n  padding-bottom: .5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
